import { cn } from "@/ui/shadcn/lib/utils";

export function EmptyField(props: { className?: string }) {
  const { className } = props;
  return (
    <span className={cn("text-sm text-muted-foreground", className)}>
      &mdash;
    </span>
  );
}
